import { render, staticRenderFns } from "./SwedenSignUp.vue?vue&type=template&id=088b4f86&scoped=true"
import script from "./SwedenSignUp.vue?vue&type=script&lang=js"
export * from "./SwedenSignUp.vue?vue&type=script&lang=js"
import style0 from "./SwedenSignUp.vue?vue&type=style&index=0&id=088b4f86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088b4f86",
  null
  
)

export default component.exports